import {Skeleton} from "@mui/material";
import React from "react";
// import "../../pages/pages.scss";
import "./callScoreLoader.scss";

const CallScoreLoader = () => {
    return <div className={"transparent-container loader-container"}>
            <div className={"white-background-container"}>
                <Skeleton animation="wave" height={40}/>
                <Skeleton animation="wave" height={40}/>
                <Skeleton animation="wave" height={40}/>
            </div>
            <div className={"white-background-container"}>
                <Skeleton animation="wave" height={40}/>
                <Skeleton animation="wave" height={40}/>
                <Skeleton animation="wave" height={40}/>
            </div>
            <div className={"white-background-container"}>
                <Skeleton animation="wave" height={40}/>
                <Skeleton animation="wave" height={40}/>
                <Skeleton animation="wave" height={40}/>
            </div>
            {/*<div className={"white-background-container"}>*/}
            {/*    <Skeleton animation="wave" height={30}/>*/}
            {/*    <Skeleton animation="wave" height={30}/>*/}
            {/*    <Skeleton animation="wave" height={30}/>*/}
            {/*</div>*/}
            {/*<div className={"white-background-container"}>*/}
            {/*    <Skeleton animation="wave" height={30}/>*/}
            {/*    <Skeleton animation="wave" height={30}/>*/}
            {/*    <Skeleton animation="wave" height={30}/>*/}
            {/*</div>*/}
        </div>
}

export default CallScoreLoader;